import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { ConfigProvider, App as AntApp } from 'antd';
import ruRU from 'antd/locale/ru_RU';

import MainLayout from './components/MainLayout';
import ProtectedRoute from './components/ProtectedRoute';
import RoleRoute from './components/RoleRoute';
import LoginPage from './pages/LoginPage';
import DashboardPage from './pages/DashboardPage';
import ProvidersPage from './pages/ProvidersPage';
import ServicesPage from './pages/ServicesPage';
import BookingsPage from './pages/BookingsPage';
import PaymentsPage from './pages/PaymentsPage';
import ReportsPage from './pages/ReportsPage';
import ReviewsPage from './pages/ReviewsPage';
import RegionsPage from './pages/RegionsPage';
import TaxAnalysisPage from './pages/TaxAnalysisPage';

import './App.css';

const themeConfig = {
  token: {
    colorPrimary: '#4f46e5',
    borderRadius: 8,
    fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
  },
  components: {
    Table: {
      headerBg: '#fafafa',
      borderRadius: 8,
    },
    Card: {
      borderRadiusLG: 12,
    },
    Button: {
      borderRadius: 8,
    },
    Input: {
      borderRadius: 8,
    },
  },
};

function App() {
  return (
    <ConfigProvider theme={themeConfig} locale={ruRU}>
      <AntApp>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<LoginPage />} />
            <Route
              path="/"
              element={
                <ProtectedRoute>
                  <MainLayout />
                </ProtectedRoute>
              }
            >
              <Route index element={<DashboardPage />} />
              <Route path="providers" element={<RoleRoute route="/providers"><ProvidersPage /></RoleRoute>} />
              <Route path="services" element={<RoleRoute route="/services"><ServicesPage /></RoleRoute>} />
              <Route path="bookings" element={<RoleRoute route="/bookings"><BookingsPage /></RoleRoute>} />
              <Route path="payments" element={<RoleRoute route="/payments"><PaymentsPage /></RoleRoute>} />
              <Route path="reports" element={<RoleRoute route="/reports"><ReportsPage /></RoleRoute>} />
              <Route path="reviews" element={<RoleRoute route="/reviews"><ReviewsPage /></RoleRoute>} />
              <Route path="regions" element={<RoleRoute route="/regions"><RegionsPage /></RoleRoute>} />
              <Route path="tax-analysis" element={<RoleRoute route="/tax-analysis"><TaxAnalysisPage /></RoleRoute>} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </AntApp>
    </ConfigProvider>
  );
}

export default App;
